import { BaseStore } from "stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import { api_get, api_post } from "api/utils"
import { CursorType } from "utils/types"
import { FileType } from "stores/file_store"
export type FileAssociationType = {
    key: string;
    uuid: string;
    identity: string;
    file: string;
    associated_type: string;
    associated_uuid: string;
    date_created: string;
    date_updated: string;
}

// Domain object FileAssociation
export class FileAssociation implements FileAssociationType {
    key = "";
    uuid = "";
    identity = "";
    file = "";
    associated_type = "";
    associated_uuid = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: FileAssociationType) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: FileAssociationType) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class FileAssociationStore extends BaseStore<FileAssociationType, FileAssociation> {


    async fetchFileAssociation(uuid: string) {
        // Autogenerated
        const response = await api_get(`/file_association?uuid=${uuid}`);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }

    async associate(identity: string,
        file: string,
        associated_type: string,
        associated_uuid: string): Promise<FileAssociationType | null> {
        const url = '/file-association/create';
        const data = {
            identity,
            file,
            associated_type,
            associated_uuid
        };
        const response = await api_post(url, data);
        if (response.ok) {
            const item = await response.json() as FileAssociationType;
            // console.log("FileAssociationStore.associate response", item);
            this.receiveUpdate(item);
            return item;

        }
        return null;
    }


    async fetchListByAssociation(identity: string, associated_type: string, associated_uuid:string, cursor?: CursorType): Promise<FileType[]>  {
        const url = "/file-association/list/by-association";
        const params = {identity, associated_type, associated_uuid, cursor: cursor || ""};
        const response = await api_get(url, params);
        if (response.ok) {
            const data = await response.json();
            this.receiveUpdate(data.items);
            if(data?.cursor) {
                this.fetchListByAssociation(identity, associated_type, associated_uuid, data.cursor);
            }
            // This returns as possibly incomplete list due to the cursor,
            // but FileStore.items is complete when .then() is called
            // so you can/should just use that.
            return data.items;
        }
        return [];
    };

    async fetchListByIdentity(identity_uuid: string, cursor?: CursorType): Promise<FileAssociationType[]>  {
        // Autogenerated
        var url = `/file-association/list/by-identity?identity=${identity_uuid}` +
            (cursor ? `&cursor=${cursor}` : '');
        const response = await api_get(url);
        if (response.ok) {
            const data = await response.json();
            this.receiveUpdate(data.items);
            if(data?.cursor) {
                this.fetchListByIdentity(identity_uuid, data.cursor);
            }
            // This returns as possibly incomplete list due to the cursor,
            // but FileAssociationStore.items is complete when .then() is called
            // so you can/should just use that.
            return data.items;
        }
        return [];
    };

    modelConstructor() {
        return FileAssociation;
    }

}
